import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getUserOrganizations, getRoles } from '../../../modules/user_api';
import ManagePersonnel from './manage-personnel/manage-personnel';

import './regional-manager-dashboard.css';

class RegionalManagerDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      organizations: [],
      roles: [],
    };
  }

  addNewlyAddedOrganizationToList(newOrganization) {
    const { organizations } = this.state;
    const newOrganizationList = [...organizations, newOrganization];
    this.setState({ organizations: newOrganizationList });
  }

  async componentDidMount() {
    const organizationsResponse = await getUserOrganizations();

    if (organizationsResponse.data.success) {
      const organizations = organizationsResponse.data.organizations;
      this.setState({ organizations: organizations });
    }

    const rolesResponse = await getRoles();

    if (rolesResponse.data.success) {
      const roles = rolesResponse.data.roles;
      this.setState({ roles: roles });
    }
  }

  render() {
    const { currentUser } = this.props;
    const { organizations, roles } = this.state;

    return (
      <div className="regional_manager_dashboard">
        <div className="regional_manager_dashboard_title">Welcome to your dashboard</div>
        <ManagePersonnel
          organizations={organizations}
          roles={roles}
          user={currentUser}
          add_new_organization_func={this.addNewlyAddedOrganizationToList.bind(this)}
        />
      </div>
    );
  }
}

const withState = connect((state) => {
  const { user } = state;
  return {
    currentUser: user,
    currentUserId: user.currentUserId,
    currentUserFirstName: user.currentUserFirstName,
  };
});

export default withRouter(withState(RegionalManagerDashboard));
